import type { IconName } from "@/shared/ui/Icon";
import type { Role } from "@/shared/api/schemas/common";

export interface NavItem {
  to: string;
  label: string;
  minimum: Role;
  icon: IconName;
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

// Разделы v1 — docs/tz/07-admin.md §3 (ADR 2026-09-11, объём v1: без Overview/Installs/Pushes/Staff).
export const NAV_GROUPS: NavGroup[] = [
  {
    title: "Библиотека",
    items: [{ to: "/config/looks", label: "Стили и шаблоны", minimum: "viewer", icon: "looks" }],
  },
  {
    title: "Конфигурация",
    items: [
      { to: "/config/onboardings", label: "Онбординги", minimum: "editor", icon: "onboarding" },
      { to: "/config/paywalls", label: "Пейволы", minimum: "editor", icon: "paywall" },
      { to: "/config/flags", label: "Флаги", minimum: "editor", icon: "flags" },
      { to: "/config/revisions", label: "Ревизии", minimum: "viewer", icon: "revisions" },
      { to: "/config/products", label: "Продукты", minimum: "viewer", icon: "products" },
    ],
  },
  {
    title: "Аналитика",
    items: [
      { to: "/analytics/funnels", label: "Воронки", minimum: "analyst", icon: "funnels" },
      {
        to: "/analytics/experiments",
        label: "Эксперименты",
        minimum: "analyst",
        icon: "experiments",
      },
    ],
  },
  {
    title: "Система",
    items: [{ to: "/system/sessions", label: "Сессии", minimum: "viewer", icon: "sessions" }],
  },
];
